export const SYNC_DELAY = 10000;